import { useQuery } from 'react-query';
import { api } from '../services/api';

export interface IPagedParams {
  resultsPerPage?: number;
  page?: number;
  name: string | undefined;
  orderBy?: string;
  orderByDirection?: string;
}

export interface ICreateFileProps {
  name: string;
  type: string;
  pageOptions: {
    page: number;
    resultsPerPage: number;
    orderByDirection: string;
  };
  duplicated: boolean;
  customFilters: {
    plate?: string;
    dueDate: {
      end?: string;
      start?: string;
    };
  };
  filters: {
    vehiclePlate?: string;
    vehicleUF?: string;
    type?: string;
    installments?: string;
    isExpirationDate?: boolean;
    isUniqueInstallments?: boolean;
    // isPaymentCompleted?: boolean;
  };
}

export interface IExportedFile {
  id: number;
  name: string;
  type: string;
  status: string;
  created_at: string;
  fileUrl: string;
}

export interface IPagedExportedFiles {
  results: IExportedFile[];
  nPages: number;
  total: number;
  resultsPerPage: string;
  currentPage: string;
}

export async function getPagedExportedFiles(
  params: IPagedParams,
): Promise<IPagedExportedFiles> {
  const { data } = await api.get(`/reports`, { params });
  return data;
}

export const createExportedFile = async (data: ICreateFileProps) => {
  return await api.post(`/reports`, data, {
    headers: {
      tokenTerminal: process.env.REACT_APP_TERMINAL,
    },
  });
};

export function usePagedFiles(params: IPagedParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    `/reports`,
    params.orderByDirection,
    params.orderBy,
    params.name,
    params.page,
    params.resultsPerPage,
  ];

  return useQuery(queryKey, () => getPagedExportedFiles(params), {
    staleTime: 60000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
